import React from "react"

const SEGMENT_BEFORE = "SAMGASTON.COM \u00a0//\u00a0 OBJECTS FOR WEAR \u00a0//\u00a0 PORTFOLIO "
const SEGMENT_AFTER  = " \u00a0\u00a0\u00a0\u00a0\u00a0\u00a0"
const CURRENT_YEAR   = new Date().getFullYear()

function Segment() {
    return (
        <span>
            {SEGMENT_BEFORE}
            <span style={{ fontFamily: '"Lunchtype", sans-serif' }}>{CURRENT_YEAR}</span>
            {SEGMENT_AFTER}
        </span>
    )
}

export default function TickerBar() {
    return (
        <div style={{
            backgroundColor: "#000",
            overflow: "hidden",
            whiteSpace: "nowrap",
            height: "48px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            margin: 0,
            padding: 0,
            boxSizing: "border-box",
            flexShrink: 0,
        }}>
            <style>{`
                body, #root { margin: 0; padding: 0; }
                @keyframes ticker-scroll {
                    0%   { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .ticker-inner {
                    display: inline-block;
                    animation: ticker-scroll 120s linear infinite;
                    will-change: transform;
                    font-family: "Fanwood", serif;
                    font-size: 24px;
                    letter-spacing: 0.06em;
                    color: #fff;
                }
                @media (max-width: 767px) {
                    .ticker-inner { font-size: 11px !important; }
                }
                @media (min-width: 768px) and (max-width: 1023px) {
                    .ticker-inner { font-size: 16px !important; }
                }
            `}</style>
            <span className="ticker-inner">
                {/* 16 copies ensures the content is always wider than 2× any viewport */}
                {Array(16).fill(null).map((_, i) => <Segment key={i} />)}
            </span>
        </div>
    )
}
